import $http from '../../shared/http';

export const users = {
  namespaced: true,
  state: () => {
    return {
      users: [],
      currentUser: {},
      currentUserProfileID: null,
      userEditData: {},
      isUserEdited: false,
    };
  },
  getters: {
    getUsers: (state) => state.users,
    getCurrentUser: (state) => state.currentUser,
    getCurrentUserProfileID: (state) => state.currentUserProfileID,
    isUserEdited: (state) => state.isUserEdited,
  },
  mutations: {
    setUsers: (state, userPayload) => {
      state.users = userPayload;
    },
    setCurrentUser: (state, payload) => {
      state.currentUser = payload;
    },
    setCurrentUserProfileID: (state, payload) => {
      state.currentUserProfileID = payload;
    },
    setUserEditData: (state, payload) => {
      delete payload.confirmPassword;
      state.userEditData = payload;
    },
    setUserEdited: (state, status) => (state.isUserEdited = status),
    initUserEditData: (state) => {
      state.userEditData.user_id = null;
      state.userEditData.role = '';
      state.userEditData.email = '';
      state.userEditData.password = '';
      state.userEditData.loginStatus = null;
      state.isUserEdited = false;
    },
  },
  actions: {
    async loadUsers({ commit }) {
      commit('setUsers', null);
      return $http()
        .get('/members')
        .then((response) => {
          commit('setUsers', response.data.users);
          return response;
        })
        .catch((error) => {
          commit('setUsers', null);
          return Promise.reject(error);
        });
    },
    async getCurrentUserActionGlobal({ commit }, { userId }) {
      return $http()
        .get(`/members/${userId}`)
        .then((response) => {
          commit('setCurrentUser', response.data.data);
          return response;
        })
        .catch((error) => {
          commit('setCurrentUser', null);
          return Promise.reject(error);
        });
    },

    async GET_NON_GLOBAL_USER_ACTION({ commit }, { userId }) {
      commit('setCurrentUser', null);
      return $http('v2')
        .get(`/users/non_global_users/${userId}`)
        .then((response) => {
          commit('setCurrentUser', response.data.data);
          return response;
        })
        .catch((error) => {
          commit('setCurrentUser', null);
          return Promise.reject(error);
        });
    },

    async EDIT_NON_GLOBAL_USER_ACTION(ctx, { form, userId }) {
      return $http('v2').put(`/users/non_global_users/${userId}`, form, { notifiable: true });
    },

    async SOFT_DELETE_NON_GLOBAL_USER_ACTION(ctx, { userId }) {
      return $http('v2').delete(`/users/non_global_users/${userId}`, { notifiable: true });
    },

    async FETCH_CHURCH_USER_ACTION({ commit }, { userId, churchId }) {
      return $http('v2')
        .get(`organisations/${churchId}/users/${userId}`, { canBeImpersonated: true })
        .then((response) => {
          commit('setCurrentUser', response.data.data);
          return response;
        })
        .catch((error) => {
          commit('setCurrentUser', null);
          return Promise.reject(error);
        });
    },
    async loadCurrentUserProfileIDGlobal({ commit }, { userId }) {
      return $http()
        .get(`/members/${userId}/profile_id`)
        .then((response) => {
          commit('setCurrentUserProfileID', response.data.data);
          return response;
        })
        .catch((error) => {
          commit('setCurrentUserProfileID', null);
          return Promise.reject(error);
        });
    },
    async loadCurrentUserProfileID({ commit }, { userId, orgId }) {
      return $http()
        .get(`/organisations/${orgId}/members/${userId}/profile_id`)
        .then((response) => {
          commit('setCurrentUserProfileID', response.data.data);
          return response;
        });
    },
    async loadUsersNoPaginate({ commit }) {
      return $http()
        .get('/members', {
          params: {
            no_paginate: true,
          },
        })
        .then((response) => {
          commit('setUsers', response.data.data);
          return response;
        })
        .catch((error) => {
          commit('setUsers', null);
          return Promise.reject(error);
        });
    },
    async editUserGlobal({ dispatch }, { form, userId }) {
      return $http()
        .put(`/members/${userId}`, form, { notifiable: true })
        .then((response) => {
          dispatch('getCurrentUserActionGlobal', { userId });
          return response;
        });
    },

    async EDIT_CHURCH_USER_ACCOUNT({ dispatch }, { userId, churchId, form }) {
      return $http('v2')
        .put(`/organisations/${churchId}/users/${userId}`, form, { notifiable: true })
        .then((response) => {
          dispatch('FETCH_CHURCH_USER_ACTION', { userId, churchId });
          return response;
        });
    },
    async deleteUser({ commit }, user_id) {
      return $http()
        .delete(`/members/${user_id}`, { notifiable: true })
        .catch((error) => {
          commit('setUserEdited', false);
          return Promise.reject(error);
        });
    },

    async fetchUser(_, user_id) {
      return $http('v2')
        .get(`/users/${user_id}`)
        .then((response) => response.data.data);
    },

    async LOAD_GLOBAL_USER(_, user_id) {
      return $http('v2')
        .get(`/global_users/${user_id}`)
        .then((response) => response.data.data);
    },
  },
};
